// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "ProdDetail" + "." + "41b7a8c7" + ".js";
};